export const mixinBank = {
    computed: {
        bankList() {
            return this.$store.getters["money/bankList"];
        }
    },
    methods: {
        onAddClick() {
            const me = this;
            if (me.bankList.length < 6) {
                me.go("UserBankEdit");
            } else {
                me.toast.show("最多可添加6张银行卡");
            }
        },
        loadList(isReLoad) {
            this.$store.dispatch("money/bankList", isReLoad);
        }
    }
}